var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchQuery($event)
                }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.language["gift_user_app"] } },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder:
                                  _vm.language["column.pleaseChoose"] +
                                  _vm.language["gift_user_app"],
                                disabled: _vm.appLimit.flag
                              },
                              on: { change: _vm.$forceUpdate },
                              model: {
                                value: _vm.queryParam.app,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryParam, "app", $$v)
                                },
                                expression: "queryParam.app"
                              }
                            },
                            _vm._l(_vm.appOptions, function(value, key) {
                              return _c(
                                "a-select-option",
                                { key: key, attrs: { value: key } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(value) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "供應商" } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入供應商" },
                            model: {
                              value: _vm.queryParam.supplier,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "supplier", $$v)
                              },
                              expression: "queryParam.supplier"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "訂單編號" } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入訂單編號" },
                            model: {
                              value: _vm.queryParam.orderno,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "orderno", $$v)
                              },
                              expression: "queryParam.orderno"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.toggleSearchStatus
                    ? [
                        _c(
                          "a-col",
                          { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "員工工號" } },
                              [
                                _c("a-input", {
                                  attrs: { placeholder: "请输入員工工號" },
                                  model: {
                                    value: _vm.queryParam.empId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.queryParam, "empId", $$v)
                                    },
                                    expression: "queryParam.empId"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "商品名稱" } },
                              [
                                _c("a-input", {
                                  attrs: { placeholder: "请输入商品名稱" },
                                  model: {
                                    value: _vm.queryParam.productName,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.queryParam,
                                        "productName",
                                        $$v
                                      )
                                    },
                                    expression: "queryParam.productName"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "員工姓名" } },
                              [
                                _c("a-input", {
                                  attrs: { placeholder: "请输入員工姓名" },
                                  model: {
                                    value: _vm.queryParam.empName,
                                    callback: function($$v) {
                                      _vm.$set(_vm.queryParam, "empName", $$v)
                                    },
                                    expression: "queryParam.empName"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "所屬法人" } },
                              [
                                _c("a-input", {
                                  attrs: { placeholder: "请输入所屬法人" },
                                  model: {
                                    value: _vm.queryParam.empCompany,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.queryParam,
                                        "empCompany",
                                        $$v
                                      )
                                    },
                                    expression: "queryParam.empCompany"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { xl: 10, lg: 11, md: 12, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "訂單成立時間" } },
                              [
                                _c("j-date", {
                                  staticClass: "query-group-cust",
                                  attrs: { placeholder: "请选择开始日期" },
                                  model: {
                                    value: _vm.queryParam.createTime_begin,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.queryParam,
                                        "createTime_begin",
                                        $$v
                                      )
                                    },
                                    expression: "queryParam.createTime_begin"
                                  }
                                }),
                                _c("span", {
                                  staticClass: "query-group-split-cust"
                                }),
                                _c("j-date", {
                                  staticClass: "query-group-cust",
                                  attrs: { placeholder: "请选择结束日期" },
                                  model: {
                                    value: _vm.queryParam.createTime_end,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.queryParam,
                                        "createTime_end",
                                        $$v
                                      )
                                    },
                                    expression: "queryParam.createTime_end"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "收件人" } },
                              [
                                _c("a-input", {
                                  attrs: { placeholder: "请输入收件人" },
                                  model: {
                                    value: _vm.queryParam.recipient,
                                    callback: function($$v) {
                                      _vm.$set(_vm.queryParam, "recipient", $$v)
                                    },
                                    expression: "queryParam.recipient"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "收件人手機號" } },
                              [
                                _c("a-input", {
                                  attrs: { placeholder: "请输入收件人手機號" },
                                  model: {
                                    value: _vm.queryParam.empMobile,
                                    callback: function($$v) {
                                      _vm.$set(_vm.queryParam, "empMobile", $$v)
                                    },
                                    expression: "queryParam.empMobile"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "收件人郵箱地址" } },
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "请输入收件人郵箱地址"
                                  },
                                  model: {
                                    value: _vm.queryParam.empEmail,
                                    callback: function($$v) {
                                      _vm.$set(_vm.queryParam, "empEmail", $$v)
                                    },
                                    expression: "queryParam.empEmail"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "訂單狀態" } },
                              [
                                _c("a-select", {
                                  attrs: {
                                    placeholder: "請選擇訂單狀態",
                                    options: _vm.statusOption
                                  },
                                  model: {
                                    value: _vm.queryParam.status,
                                    callback: function($$v) {
                                      _vm.$set(_vm.queryParam, "status", $$v)
                                    },
                                    expression: "queryParam.status"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _c("a-col", { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" }
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery }
                          },
                          [_vm._v("查询")]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset }
                          },
                          [_vm._v("重置")]
                        ),
                        _c(
                          "a",
                          {
                            staticStyle: { "margin-left": "8px" },
                            on: { click: _vm.handleToggleSearch }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.toggleSearchStatus ? "收起" : "展开"
                                ) +
                                "\n              "
                            ),
                            _c("a-icon", {
                              attrs: {
                                type: _vm.toggleSearchStatus ? "up" : "down"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "download" },
              on: {
                click: function($event) {
                  return _vm.handleExportXls("訂單明細")
                }
              }
            },
            [_vm._v("导出")]
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c("a-table", {
            ref: "table",
            staticClass: "j-table-force-nowrap",
            attrs: {
              size: "middle",
              scroll: { x: true },
              bordered: "",
              rowKey: "orderno",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function(text, record) {
                  return _c("span", {}, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.handleDetail(record)
                          }
                        }
                      },
                      [_vm._v("详情")]
                    )
                  ])
                }
              }
            ])
          })
        ],
        1
      ),
      _c("view-order-user-detail-modal", {
        ref: "modalForm",
        on: { ok: _vm.modalFormOk }
      }),
      _c("OrderTmsForm", { ref: "OrderTmsForm", on: { ok: _vm.modalFormOk } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }